import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo-white-no-title.svg';
import './footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="site-footer__top">
        <div className="site-footer__brand">
          <Link className="brand" to="/" aria-label="TryOuts home">
            <img src={logo} alt="" width="36" height="36" />
            <span>TRYOUTS</span>
          </Link>
          <p>Production AI systems for founders who are ready to move beyond the demo.</p>
        </div>

        <div className="site-footer__links" aria-label="Footer navigation">
          <div>
            <h2>Explore</h2>
            <Link to="/#work">Work</Link>
            <Link to="/#capabilities">Capabilities</Link>
            <Link to="/#process">Process</Link>
            <Link to="/blog">Insights</Link>
          </div>
          <div>
            <h2>Company</h2>
            <Link to="/#about">About</Link>
            <Link to="/#labs">TryOuts Labs</Link>
            <Link to="/contact">Start a project</Link>
          </div>
          <div>
            <h2>Connect</h2>
            <a href="mailto:contact@tryouts.tech">Email</a>
            <a href="https://www.linkedin.com/company/tryouts-tech" target="_blank" rel="noreferrer">LinkedIn</a>
            <a href="https://www.instagram.com/t.r.y.o.u.t.s/" target="_blank" rel="noreferrer">Instagram</a>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} TryOuts Technologies.</span>
        <span>Built in India. Working globally.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
